import Header from '../components/Header';
import * as locCon from '../LocalConstants';
import * as libCon from '../community-hats-js-library/Constants';
import CustomButton from '../elements/CustomButton';

import {} from '../hooks/NavigationHooks';
import { getParticipantReportFromBucket } from '../community-hats-js-library/back-end/router';
import { useState } from 'react';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import CustomSpin from '../elements/CustomSpin';
import { RefLanguageAndLocale } from '../hooks/LanguageHooks';
import { RefATOField } from '../hooks/StoreHooks';
import { useEffect } from 'react';
import {
  getDaysBetweenDates,
  nowInStudyLocation,
} from '../community-hats-js-library/utils/dateFunctions';
import CustomText from '../elements/CustomText';
import { showError, showNotification } from '../utils/generalFunctions';

export function ParticipantReport() {
  const [i18n, locale] = RefLanguageAndLocale();

  // Sewa ID
  const sewaId = RefATOField(locCon.AT_OBJECT_PARTICIPANT, libCon.ATF_SEWA_ID);
  const name = RefATOField(locCon.AT_OBJECT_PARTICIPANT, libCon.ATF_NAME);
  const lastName = RefATOField(
    locCon.AT_OBJECT_PARTICIPANT,
    libCon.ATF_LAST_NAME
  );
  const [loadingHtml, setLoadingHtml] = useState(false);
  const [participantReports, setParticipantReports] = useState({});

  const [html, sethtml] = useState(null);

  const loadReport = async () => {
    setLoadingHtml(true);

    const [status, response] = await getParticipantReportFromBucket(
      sewaId,
      locale
    );

    if (status === libCon.OK) {
      // Saves
      setParticipantReports({
        ...participantReports,
        [locale]: {
          [locCon.REPORT_DATE]: nowInStudyLocation(true),
          [locCon.REPORT]: response,
        },
      });
      showNotification(i18n.t('reportLoaded'));
    } else showError(i18n.t('noReportFound'));

    setLoadingHtml(false);
  };

  useEffect(() => {
    // Checks if the report is available
    if (
      !isNullOrUndefined(participantReports) &&
      locale in participantReports &&
      locCon.REPORT_DATE in participantReports[locale] &&
      getDaysBetweenDates(
        participantReports[locale][locCon.REPORT_DATE],
        new Date()
      ) < 10
    ) {
      sethtml(participantReports[locale][locCon.REPORT]);
    } else sethtml(null);
  }, [participantReports, locale]);

  return (
    <div
      className="mainAppContainer"
      style={{ backgroundColor: 'var(--background-color-1-solid)' }}
    >
      <div
        className="pageContainer"
        style={{ backgroundColor: 'var(--background-color-1)' }}
      >
        <Header long={false} />
        {isNullOrUndefined(html) ? (
          <div className="verticalSection" style={{ marginTop: '3vh' }}>
            {loadingHtml ? (
              <CustomSpin type={locCon.BUTTON_SPINNER} />
            ) : (
              <CustomButton
                type={locCon.PRIMARY_BUTTON}
                onClick={() => loadReport()}
              >
                {i18n.t('loadParticipantReport')}
              </CustomButton>
            )}
          </div>
        ) : (
          <div className="verticalSection" style={{ marginTop: '2vh' }}>
            <CustomText type={locCon.MODULE_TITLE_TEXT}>
              {i18n.t('reportTitle')}
            </CustomText>
            <CustomText
              type={locCon.SECTION_TITLE_TEXT}
            >{`${name} ${lastName}`}</CustomText>
            <div
              style={{ marginTop: '1vh', marginBottom: '5vh' }}
              className="htmlContainer"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ParticipantReport;
